import { FloatingPanelSeparator } from "@babackapp/ui/components/floating-panel";
import PanelContainer from "../../lib/panel/panel-container";
import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import PanelBlockFont from "../../lib/panel/panel-block-font";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { EmailPanelStyle } from "../button/email-panel-style";
import { ReturnDownloadLabelPanelLabel } from "./email-panel-label";
import type { ReturnDownloadLabelBlockProps } from "./types";

export function ReturnDownloadLabelPanelRenderer(
  blockProps: ReturnDownloadLabelBlockProps,
) {
  return (
    <PanelContainer blockProps={blockProps}>
      <ReturnDownloadLabelPanelLabel
        field="label"
        titleKey="editorBlocksLibrary.blocks.return-download-label.panel.label.title"
        titleFallback="Label (shipping label)"
        placeholderFallback="Download my label"
      />
      <FloatingPanelSeparator />
      <ReturnDownloadLabelPanelLabel
        field="bonDeRetour"
        titleKey="editorBlocksLibrary.blocks.return-download-label.panel.bonDeRetour.title"
        titleFallback="Label (return slip)"
        placeholderFallback="Download my return slip"
      />
      <FloatingPanelSeparator />
      <EmailPanelStyle />
      <FloatingPanelSeparator />
      <PanelBlockFont />
      <PanelBlockAlignment />
      <PanelTranslationState mode="translatable" portal />
    </PanelContainer>
  );
}
